module.exports = __webpack_public_path__ + "static/media/teytu-BN.99ba56a0.png";